let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iuoG7")).then(() => parcelRequire('6SIp8'));